import InAppSpy from 'inapp-spy';

export const hasWindow = () => typeof window !== 'undefined';

export const hasNavigatorApi = (api: string) =>
  hasWindow() && typeof navigator !== 'undefined' && api in navigator;

const hasNavigator = () => hasWindow() && typeof navigator !== 'undefined';

export const isiOSDevice = () =>
  hasNavigator() && /iPhone|iPad|iPod/i.test(navigator.userAgent);

// SSO Google is not permitted in the in-app browser or native app webviews
export const isGoogleSSODisabled = () => {
  return isInAppBrowser() || isNativeWebView();
};

export const isInAppBrowser = () => {
  if (!hasNavigator()) return false;

  return InAppSpy().isInApp;
};

const isNativeWebView = () => {
  if (!hasNavigator()) return false;

  const ua = navigator.userAgent;

  return (
    // React Native WebView checks
    // Android WebView
    window.ReactNativeWebView !== undefined ||
    ua.includes('ReactNativeWebView') ||
    window.webkit?.messageHandlers?.ReactNativeWebView !== undefined ||
    // Native WebView checks
    // iOS WKWebView
    ua.includes('wkwebview') ||
    // iOS WebView (non-Safari)
    (!ua.includes('safari') && ua.includes('iphone')) ||
    (ua.includes('Android') && ua.includes('wv'))
  );
};
